export const ru = {
    country: 'Страна',
    disclaimer: 'Предупреждение'
};
